module.exports = __webpack_public_path__ + "img/blockables-arrows.ed87a290.svg";